import type { VisualViewportCssSnapshot } from "./sync-visual-viewport-css";
import { KEYBOARD_CLOSE_OFFSET_PX } from "./visual-viewport-keyboard-thresholds";

/**
 * iOS Safari (incl. iOS 26) often leaves `visualViewport.offsetTop` > 0 after the
 * keyboard is dismissed. Reset layout metrics so fixed dashboard shells expand.
 *
 * Run whenever the keyboard is gone (`keyboardOffset` below close threshold), even
 * if a field stays focused — users often dismiss the keyboard with Done while the
 * caret remains in Notes; skipping normalization leaves drawers stuck at keyboard height.
 */
export function normalizeClosedVisualViewportSnapshot(
  snapshot: VisualViewportCssSnapshot,
): VisualViewportCssSnapshot {
  if (snapshot.keyboardOffsetPx >= KEYBOARD_CLOSE_OFFSET_PX) {
    return snapshot;
  }

  return {
    visualVhPx: window.innerHeight,
    offsetTopPx: 0,
    keyboardOffsetPx: 0,
  };
}
